import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

export function authGuard(): CanActivateFn {
    return () => {
        const authService: AuthenticationService = inject(AuthenticationService);
        return authService.hasLoggedIn;
    }
}